import Layout from "@components/Layout";
import { Alert, Headline, SubHeadline } from "@entrecode/statsapp-components";
import Button from "@entrecode/statsapp-components/components/Button";
import {
  createBrowserRouter,
  useNavigate,
  useRouteError,
} from "react-router";
import ClubDetail from "./ClubDetail";
import CustomerDetail from "./CustomerDetail";
import { Overview } from "./Overview";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          index: true,
          element: <Overview />,
        },
        {
          path: ":id",
          children: [
            {
              index: true,
              element: <CustomerDetail />,
            },
            {
              path: ":clubId",
              element: <ClubDetail />,
            },
          ],
        },
        {
          path: "/unauthorized",
          element: <Unauthorized />,
        },
      ],
    },
  ],
  {
    future: {
      v7_normalizeFormMethod: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_partialHydration: true,
      v7_startTransition: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

function ErrorBoundary() {
  const error = useRouteError() as any;
  const navigate = useNavigate();

  // Uncaught ReferenceError: path is not defined
  return (
    <div className="w-screen h-screen flex max-w-xs m-auto flex-col gap-3 items-center justify-center">
      <Headline>Es ist ein Fehler aufgetreten</Headline>
      <Alert type="error">
        <p>{error?.message}</p>
      </Alert>
      <Button primary onClick={() => navigate("/")}>
        Zurück
      </Button>
    </div>
  );
}

function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className="w-full h-screen flex flex-col gap-3 p-3 text-center items-center justify-center">
      <Headline>Keine Berechtigung die angefragte Seite zu sehen</Headline>
      <SubHeadline>Kontaktiere deinen Administrator </SubHeadline>
      <Button primary onClick={() => navigate("/")}>
        Zurück
      </Button>
    </div>
  );
}
export default router;
